import { render } from "./ChargebeeUpsellConfig.vue?vue&type=template&id=33f0b494&scoped=true"
import script from "./ChargebeeUpsellConfig.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellConfig.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellConfig.vue?vue&type=style&index=0&id=33f0b494&lang=scss"
import "./ChargebeeUpsellConfig.vue?vue&type=style&index=1&id=33f0b494&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f0b494"]])

export default __exports__